import axios from 'axios';

const addEmployeeApi = async (values, token, langIsoCode, edit = false) => {
  const url = !edit ? '/Employee/createEmployee' : '/Employee/editEmployee';
  try {
    const res = await axios.post(url, values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addEmployeeApi;
